// extracted by mini-css-extract-plugin
module.exports = {"candidateIdForm":"styles_candidateIdForm__3h3hv","errorResponse":"styles_errorResponse__1Stg6"};